<div class="flex flex-col gap-10 py-10 px-6 text-center">
    <img src="success-feedback.png" class="w-[80%] block mx-auto" alt="" />

    <div>
        <h2 class="font-bold text-2xl md:text-3xl">{{ data.title }}</h2>
        <p class="mt-5">{{ data.message }}</p>
    </div>

    <app-button [mat-dialog-close]="true">
        {{ data.action }}
    </app-button>
</div>